import script from "./ModalProgramGroupInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalProgramGroupInfo.vue?vue&type=script&setup=true&lang=js"

import "./ModalProgramGroupInfo.vue?vue&type=style&index=0&id=010bc06a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-010bc06a"]])

export default __exports__